import { app } from '../../app.module'
app
  // 選択したタグを全て選択解除するボタン
  .directive('batchTagResetButton', () => {
    return {
      restrict: 'E',
      template: require('./batch-tag-reset-button.pug')(),
      controller: function ($scope) {
        // ボタンを押した場合、選択したタグを全て解除するイベントを送信
        $scope.reset = function () {
          $scope.$emit('resetAllSelectedIds')
        }
      },
    }
  })
